import Card from '../atoms/Card'
import { styled } from '../../styles/settings/theme'

const TeamSettingsContainer = styled(Card)`
  background: ${props => props.theme.colors.white};
  border-radius: 0px 6px;
`

export default TeamSettingsContainer
